import React, { useState } from 'react';
import { Copy, Share2, Check, BookOpen, ChevronLeft, ChevronRight, Calendar, Sparkles, RotateCcw } from 'lucide-react';
import Swal from 'sweetalert2';

export interface Reflection {
    day: number;
    theme: string;
    ayah: string;
    translation: string;
    source: string;
    hikmah: string;
}

export const REFLECTIONS: Reflection[] = [
    {
        day: 1,
        theme: "Kemudahan Bersama Kesulitan",
        ayah: "فَإِنَّ مَعَ الْعُسْرِ يُسْرًا ۝ إِنَّ مَعَ الْعُسْرِ يُسْرًا",
        translation: "Maka sesungguhnya beserta kesulitan ada kemudahan, sesungguhnya beserta kesulitan ada kemudahan.",
        source: "QS. Al-Insyirah: 5-6",
        hikmah: "Tidak ada ujian yang abadi. Di balik satu kesulitan yang kita keluhkan, Allah selalu menyisipkan dua kemudahan yang siap menguatkan jiwa."
    },
    {
        day: 2,
        theme: "Kedekatan Allah & Pengabulan Doa",
        ayah: "وَإِذَا سَأَلَكَ عِبَادِي عَنِّي فَإِنِّي قَرِيبٌ ۖ أُجِيبُ دَعْوَةَ الدَّاعِ إِذَا دَعَانِ",
        translation: "Dan apabila hamba-hamba-Ku bertanya kepadamu tentang Aku, maka (jawablah) bahwasanya Aku adalah dekat. Aku mengabulkan permohonan orang yang berdoa apabila ia memohon kepada-Ku.",
        source: "QS. Al-Baqarah: 186",
        hikmah: "Allah tidak pernah jauh dari rintihan hamba-Nya. Dekatkan hati dan adukan seluruh kegundahanmu hanya di hadapan-Nya."
    },
    {
        day: 3,
        theme: "Puncak Tawakkal & Ketenangan",
        ayah: "وَمَن يَتَوَكَّلْ عَلَى اللَّهِ فَهُوَ حَسْبُهُ ۚ إِنَّ اللَّهَ بَالِغُ أَمْرِهِ",
        translation: "Dan barangsiapa yang bertawakkal kepada Allah niscaya Allah akan mencukupkan (keperluan)nya. Sesungguhnya Allah melaksanakan urusan yang (dikehendaki)-Nya.",
        source: "QS. At-Talaq: 3",
        hikmah: "Ketika seluruh ikhtiar telah maksimal ditunaikan, pasrahkan hasilnya kepada Allah; Dia adalah sebaik-baik penjamin hidupmu."
    },
    {
        day: 4,
        theme: "Ujian Sesuai Kesanggupan",
        ayah: "لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا وُسْعَهَا",
        translation: "Allah tidak membebani seseorang melainkan sesuai dengan kesanggupannya.",
        source: "QS. Al-Baqarah: 286",
        hikmah: "Jika Allah mengizinkan suatu beban menghampirimu, itu pertanda Allah tahu bahumu cukup kuat untuk memikul dan melaluinya."
    },
    {
        day: 5,
        theme: "Ketenangan Melalui Dzikir",
        ayah: "الَّذِينَ آمَنُوا وَتَطْمَئِنُّ قُلُوبُهُم بِذِكْرِ اللَّهِ ۗ أَلَا بِذِكْرِ اللَّهِ تَطْمَئِنُّ الْقُلُوبُ",
        translation: "Ingatlah, hanya dengan mengingat Allah hati menjadi tenteram.",
        source: "QS. Ar-Ra'd: 28",
        hikmah: "Dunia bisa membuat lelah dan cemas, namun satu tarikan nafas berdzikir mampu mengembalikan damai di dalam rongga dada."
    },
    {
        day: 6,
        theme: "Janji Kelipatan Syukur",
        ayah: "لَئِن شَكَرْتُمْ لَأَزِيدَنَّكُمْ ۖ وَلَئِن كَفَرْتُمْ إِنَّ عَذَابِي لَشَدِيدٌ",
        translation: "Sesungguhnya jika kamu bersyukur, pasti Kami akan menambah (nikmat) kepadamu.",
        source: "QS. Ibrahim: 7",
        hikmah: "Syukur adalah magnet keberkahan; semakin kita menghargai nikmat kecil hari ini, semakin Allah luaskan pintu kebahagiaan."
    },
    {
        day: 7,
        theme: "Skenario Terbaik Sang Maha Mengetahui",
        ayah: "وَعَسَىٰ أَن تَكْرَهُوا شَيْئًا وَهُوَ خَيْرٌ لَّكُمْ ۖ وَاللَّهُ يَعْلَمُ وَأَنتُمْ لَا تَعْلَمُونَ",
        translation: "Boleh jadi kamu membenci sesuatu padahal ia amat baik bagimu; Allah mengetahui, sedang kamu tidak mengetahui.",
        source: "QS. Al-Baqarah: 216",
        hikmah: "Lepaskan kekecewaan atas rencana yang tertunda; takdir Allah selalu lebih indah dari rencana terbaik manusia."
    },
    {
        day: 8,
        theme: "Luasnya Rahmat & Ampunan",
        ayah: "قُلْ يَا عِبَادِيَ الَّذِينَ أَسْرَفُوا عَلَىٰ أَنفُسِهِمْ لَا تَقْنَطُوا مِن رَّحْمَةِ اللَّهِ ۚ إِنَّ اللَّهَ يَغْفِرُ الذُّنُوبَ جَمِيعًا",
        translation: "Katakanlah: 'Hai hamba-hamba-Ku yang melampaui batas terhadap diri mereka sendiri, janganlah kamu berputus asa dari rahmat Allah. Sesungguhnya Allah mengampuni dosa-dosa semuanya'.",
        source: "QS. Az-Zumar: 53",
        hikmah: "Sebesar apapun kekhilafan masa lalumu, pintu ampunan Allah selalu lebih luas daripada bumi dan seisinya."
    },
    {
        day: 9,
        theme: "Pahala Sabar Tanpa Batas",
        ayah: "إِنَّمَا يُوَفَّى الصَّابِرُونَ أَجْرَهُم بِغَيْرِ حِسَابٍ",
        translation: "Sesungguhnya hanya orang-orang yang bersabarlah yang disempurnakan pahalanya tanpa batas.",
        source: "QS. Az-Zumar: 10",
        hikmah: "Sabar memang pahit di awal, namun keindahan buahnya tak bertepi dan senantiasa diridhai Allah Ta'ala."
    },
    {
        day: 10,
        theme: "Penolong Jiwa: Sabar & Sholat",
        ayah: "وَاسْتَعِينُوا بِالصَّبْرِ وَالصَّلَاةِ ۚ وَإِنَّهَا لَكَبِيرَةٌ إِلَّا عَلَى الْخَاشِعِينَ",
        translation: "Jadikanlah sabar dan sholat sebagai penolongmu. Dan sesungguhnya yang demikian itu sungguh berat, kecuali bagi orang-orang yang khusyuk.",
        source: "QS. Al-Baqarah: 45",
        hikmah: "Saat logika buntu dan dunia terasa sempit, tundukkan keningmu dalam sujud; sholat adalah jembatan menuju jalan keluar."
    },
    {
        day: 11,
        theme: "Balasan Kebaikan Sekecil Dzarrah",
        ayah: "فَمَن يَعْمَلْ مِثْقَالَ ذَرَّةٍ خَيْرًا يَرَهُ",
        translation: "Barangsiapa yang mengerjakan kebaikan seberat dzarrah pun, niscaya dia akan melihat (balasan)nya.",
        source: "QS. Az-Zalzalah: 7",
        hikmah: "Jangan remehkan senyuman tulus atau sebutir kurma yang kau bagikan; setiap butir kebaikan abadi dalam catatan malaikat."
    },
    {
        day: 12,
        theme: "Penyertaan Allah bagi yang Bertaqwa",
        ayah: "إِنَّ اللَّهَ مَعَ الَّذِينَ اتَّقَوا وَّالَّذِينَ هُم مُّحْسِنُونَ",
        translation: "Sesungguhnya Allah beserta orang-orang yang bertakwa dan orang-orang yang berbuat kebaikan.",
        source: "QS. An-Nahl: 128",
        hikmah: "Kebaikan yang kau tebar tulus dari lubuk hati akan selalu dijaga dan dibalas dengan perlindungan dari-Nya."
    },
    {
        day: 13,
        theme: "Kelipatan Berkah Sedekah",
        ayah: "مَّثَلُ الَّذِينَ يُنفِقُونَ أَمْوَالَهُمْ فِي سَبِيلِ اللَّهِ كَمَثَلِ حَبَّةٍ أَنبَتَتْ سَبْعَ سَنَابِلَ فِي كُلِّ سُنبُلَةٍ مِّائَةُ حَبَّةٍ",
        translation: "Perumpamaan orang yang menafkahkan hartanya di jalan Allah serupa dengan sebutir benih yang menumbuhkan tujuh bulir, pada tiap-tiap bulir seratus biji.",
        source: "QS. Al-Baqarah: 261",
        hikmah: "Harta yang disedekahkan hakikatnya tidak pernah berkurang; ia berakar menjadi naungan penyejuk di akhirat kelak."
    },
    {
        day: 14,
        theme: "Rezeki dari Arah Tak Terduga",
        ayah: "وَمَن يَتَّقِ اللَّهَ يَجْعَل لَّهُ مَخْرَجًا ۝ وَيَرْزُقْهُ مِنْ حَيْثُ لَا يَحْتَسِبُ",
        translation: "Barangsiapa bertakwa kepada Allah niscaya Dia akan mengadakan baginya jalan keluar, dan memberinya rezeki dari arah yang tiada disangka-sangkanya.",
        source: "QS. At-Talaq: 2-3",
        hikmah: "Ketaatan membuka pintu-pintu kemudahan yang tak mampu diraih oleh sekadar kalkulasi logika manusia."
    },
    {
        day: 15,
        theme: "Ikhtiar Mengubah Diri",
        ayah: "إِنَّ اللَّهَ لَا يُغَيِّرُ مَا بِقَوْمٍ حَتَّىٰ يُغَيِّرُوا مَا بِأَنفُسِهِمْ",
        translation: "Sesungguhnya Allah tidak mengubah keadaan suatu kaum sehingga mereka mengubah keadaan yang ada pada diri mereka sendiri.",
        source: "QS. Ar-Ra'd: 11",
        hikmah: "Transformasi besar dalam kehidupan diawali dari tekad kecil hari ini: memperbaiki sholat, niat, dan amalan harian."
    },
    {
        day: 16,
        theme: "Kemuliaan Berbakti pada Orang Tua",
        ayah: "وَقَضَىٰ رَبُّكَ أَلَّا تَعْبُدُوا إِلَّا إِيَّاهُ وَبِالْوَالِدَيْنِ إِحْسَانًا",
        translation: "Dan Tuhanmu telah memerintahkan supaya kamu jangan menyembah selain Dia dan hendaklah kamu berbuat baik pada ibu bapakmu dengan sebaik-baiknya.",
        source: "QS. Al-Isra: 23",
        hikmah: "Tutur kata santun dan doa tulus untuk orang tua adalah magnet terkuat turunnya ridha dan keberkahan langit."
    },
    {
        day: 17,
        theme: "Keutamaan Berkata yang Baik",
        ayah: "وَقُل لِّعِبَادِي يَقُولُوا الَّتِي هِيَ أَحْسَنُ ۚ إِنَّ الشَّيْطَانَ يَنزَغُ بَيْنَهُمْ",
        translation: "Dan katakanlah kepada hamba-hamba-Ku: 'Hendaklah mereka mengucapkan perkataan yang lebih baik (benar)'.",
        source: "QS. Al-Isra: 53",
        hikmah: "Satu kalimat yang lembut dapat memulihkan hati yang terluka; pilihlah perkataan yang mendamaikan, bukan melukai."
    },
    {
        day: 18,
        theme: "Bersegera Meraih Ampunan",
        ayah: "وَسَارِعُوا إِلَىٰ مَغْفِرَةٍ مِّن رَّبِّكُمْ وَجَنَّةٍ عَرْضُهَا السَّمَاوَاتُ وَالْأَرْضُ أُعِدَّتْ لِلْمُتَّقِينَ",
        translation: "Dan bersegeralah kamu kepada ampunan dari Tuhanmu dan kepada surga yang luasnya seluas langit dan bumi.",
        source: "QS. Ali 'Imran: 133",
        hikmah: "Waktu tidak pernah menunggu. Jangan tunda taubat dan kebaikan, sebab pintu maghfirah Allah selalu terbuka luas."
    },
    {
        day: 19,
        theme: "Membalas dengan Kebaikan (Ihsan)",
        ayah: "ادْفَعْ بِالَّتِي هِيَ أَحْسَنُ فَإِذَا الَّذِي بَيْنَكَ وَبَيْنَهُ عَدَاوَةٌ كَأَنَّهُ وَلِيٌّ حَمِيمٌ",
        translation: "Tolaklah (kejahatan itu) dengan cara yang lebih baik, maka tiba-tiba orang yang antaramu dan antara dia ada permusuhan seolah-olah telah menjadi teman yang sangat setia.",
        source: "QS. Fussilat: 34",
        hikmah: "Menjawab cercaan dengan senyuman dan doa adalah kemenangan akhlak tertinggi seorang muslimah sejati."
    },
    {
        day: 20,
        theme: "Kemuliaan Lailatul Qadar",
        ayah: "لَيْلَةُ الْقَدْرِ خَيْرٌ مِّنْ أَلْفِ شَهْرٍ",
        translation: "Malam kemuliaan itu lebih baik dari seribu bulan.",
        source: "QS. Al-Qadr: 3",
        hikmah: "Satu malam yang dilimpahi kedamaian dan pengampunan; muliakan 10 malam terakhir dengan munajat dan tadabbur penuh cinta."
    },
    {
        day: 21,
        theme: "Cahaya Petunjuk Ilahi",
        ayah: "اللَّهُ نُورُ السَّمَاوَاتِ وَالْأَرْضِ",
        translation: "Allah (Pemberi) cahaya (kepada) langit dan bumi.",
        source: "QS. An-Nur: 35",
        hikmah: "Hati yang senantiasa mendekat kepada Al-Qur'an akan selalu menemukan lentera penunjuk arah di tengah kegelapan dunia."
    },
    {
        day: 22,
        theme: "Jiwa yang Tenang & Ridha",
        ayah: "يَا أَيَّتُهَا النَّفْسُ الْمُطْمَئِنَّةُ ۝ ارْجِعِي إِلَىٰ رَبِّكِ رَاضِيَةً مَّرْضِيَّةً",
        translation: "Wahai jiwa yang tenang! Kembalilah kepada Tuhanmu dengan hati yang puas lagi diridhai-Nya.",
        source: "QS. Al-Fajr: 27-28",
        hikmah: "Puncak ketenangan seorang hamba terwujud saat hatinya ridha terhadap ketentuan Allah dan Allah pun meridhai langkahnya."
    },
    {
        day: 23,
        theme: "Amal Saleh yang Kekal Abadi",
        ayah: "الْمَالُ وَالْبَنُونَ زِينَةُ الْحَيَاةِ الدُّنْيَا ۖ وَالْبَاقِيَاتُ الصَّالِحَاتُ خَيْرٌ عِندَ رَبِّكَ ثَوَابًا وَخَيْرٌ أَمَلًا",
        translation: "Harta dan anak-anak adalah perhiasan kehidupan dunia, tetapi amalan-amalan yang kekal lagi saleh adalah lebih baik pahalanya di sisi Tuhanmu serta lebih baik untuk menjadi harapan.",
        source: "QS. Al-Kahf: 46",
        hikmah: "Segala perhiasan dunia akan berlalu, namun sujud, sedekah, dan tilawahmu akan menjadi teman setia di keabadian."
    },
    {
        day: 24,
        theme: "Keyakinan pada Takdir Allah",
        ayah: "قُل لَّن يُصِيبَنَا إِلَّا مَا كَتَبَ اللَّهُ لَنَا هُوَ مَوْلَانَا ۚ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
        translation: "Katakanlah: 'Sekali-kali tidak akan menimpa kami melainkan apa yang telah ditetapkan Allah untuk kami. Dialah Pelindung kami'.",
        source: "QS. At-Taubah: 51",
        hikmah: "Apa yang ditakdirkan untukmu takkan pernah melewatkanmu; yakinlah bahwa ketetapan Rabb-mu selalu berujung kebaikan."
    },
    {
        day: 25,
        theme: "Kebaikan Dunia & Akhirat",
        ayah: "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
        translation: "Ya Tuhan kami, berilah kami kebaikan di dunia dan kebaikan di akhirat dan peliharalah kami dari siksa neraka.",
        source: "QS. Al-Baqarah: 201",
        hikmah: "Doa sapu jagad yang memadukan kesuksesan duniawi yang berkah serta keselamatan abadi di pelataran surga."
    },
    {
        day: 26,
        theme: "Kelapangan Dada & Kemudahan Urusan",
        ayah: "رَبِّ اشْرَحْ لِي صَدْرِي ۝ وَيَسِّرْ لِي أَمْرِي",
        translation: "Ya Tuhanku, lapangkanlah dadaku, dan mudahkanlah untukku urusanku.",
        source: "QS. Thaha: 25-26",
        hikmah: "Ketika hati dilapangkan oleh Allah, rintangan sebesar gunung pun akan terasa ringan untuk dilalui."
    },
    {
        day: 27,
        theme: "Keteguhan Hati & Istiqomah",
        ayah: "رَبَّنَا لَا تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِن لَّدُنكَ رَحْمَةً ۚ إِنَّكَ أَنتَ الْوَهَّابُ",
        translation: "Ya Tuhan kami, janganlah Engkau jadikan hati kami condong kepada kesesatan sesudah Engkau beri petunjuk kepada kami, dan karuniakanlah kepada kami rahmat.",
        source: "QS. Ali 'Imran: 8",
        hikmah: "Hidayah adalah anugerah termahal; sirami terus dengan doa dan istighfar agar senantiasa berakar kokoh di dalam sanubari."
    },
    {
        day: 28,
        theme: "Pengawasan Allah yang Maha Teliti",
        ayah: "يَعْلَمُ خَائِنَةَ الْأَعْيُنِ وَمَا تُخْفِي الصُّدُورُ",
        translation: "Dia mengetahui (pandangan) mata yang khianat dan apa yang disembunyikan oleh hati.",
        source: "QS. Ghafir: 19",
        hikmah: "Ikhlaskan niat dalam setiap kebaikan tersembunyi; Allah melihat setiap tetes air mata dan ketulusanmu yang tak terucap."
    },
    {
        day: 29,
        theme: "Nikmat yang Tak Terhingga",
        ayah: "وَإِن تَعُدُّوا نِعْمَةَ اللَّهِ لَا تُحْصُوهَا ۗ إِنَّ اللَّهَ لَغَفُورٌ رَّحِيمٌ",
        translation: "Dan jika kamu menghitung-hitung nikmat Allah, niscaya kamu tak dapat menentukan jumlahnya. Sesungguhnya Allah benar-benar Maha Pengampun lagi Maha Penyayang.",
        source: "QS. An-Nahl: 18",
        hikmah: "Dari detak jantung hingga tarikan nafas setiap detik, nikmat-Nya melimpah ruah; jadikan harimu senantiasa bertasbih penuh syukur."
    },
    {
        day: 30,
        theme: "Kemenangan Jiwa yang Suci (Tazkiyah)",
        ayah: "قَدْ أَفْلَحَ مَن تَزَكَّىٰ ۝ وَذَكَرَ اسْمَ رَبِّهِ فَصَلَّىٰ",
        translation: "Sesungguhnya beruntunglah orang yang menyucikan diri, dan dia ingat nama Tuhannya, lalu dia bersembahyang.",
        source: "QS. Al-A'la: 14-15",
        hikmah: "Puncak kebahagiaan seorang hamba adalah lahirnya jiwa yang bersih, pemaaf, dan senantiasa rindu bersujud kepada Allah SWT."
    }
];

interface DailyReflectionCardProps {
    className?: string;
    showTitle?: boolean;
}

export const DailyReflectionCard: React.FC<DailyReflectionCardProps> = ({ className = '', showTitle = true }) => {
    // Rotasi otomatis default berdasarkan tanggal hari ini (1..30)
    const todayDate = new Date().getDate(); // 1 - 31
    const todayIndex = ((todayDate - 1) % REFLECTIONS.length);

    const [index, setIndex] = useState<number>(todayIndex);
    const [copied, setCopied] = useState(false);

    const current = REFLECTIONS[index];
    const isToday = index === todayIndex;

    const handleNext = () => {
        setIndex((prev) => (prev + 1) % REFLECTIONS.length);
        setCopied(false);
    };

    const handlePrev = () => {
        setIndex((prev) => (prev - 1 + REFLECTIONS.length) % REFLECTIONS.length);
        setCopied(false);
    };

    const handleResetToday = () => {
        setIndex(todayIndex);
        setCopied(false);
    };

    const handleCopy = () => {
        const textToCopy = `✨ Daily Reflection Hari ke-${current.day} (QS. ${current.source.replace('QS. ', '')})\n\n"${current.ayah}"\n\nArtinya:\n"${current.translation}"\n\n🌿 Tadabbur:\n${current.hikmah}\n\nShared via Khazanah Alwahda Kreatif`;
        navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleShare = () => {
        const textToShare = `Daily Reflection Hari ke-${current.day}: "${current.ayah}" - Artinya: ${current.translation} (${current.source})`;
        if (navigator.share) {
            navigator.share({
                title: `Daily Reflection Hari ke-${current.day} - Khazanah`,
                text: textToShare,
                url: window.location.href,
            }).catch(console.error);
        } else {
            Swal.fire({
                title: `Bagikan Refleksi Hari ke-${current.day}`,
                html: `<p class="text-sm text-gray-600 mb-4">Salin teks di bawah ini untuk dibagikan:</p>
                       <textarea class="w-full p-3 border border-gray-200 rounded-xl text-xs bg-gray-50 focus:outline-none resize-none font-mono" rows="6" readonly>${textToShare}</textarea>`,
                confirmButtonText: 'Tutup',
                confirmButtonColor: '#0F5B30'
            });
        }
    };

    return (
        <div className={`bg-white border border-emerald-900/10 shadow-lg rounded-3xl p-6 sm:p-8 max-w-3xl mx-auto relative overflow-hidden text-center transition-all ${className}`}>
            {/* Header: Badge Hari & Navigasi Cepat */}
            <div className="flex flex-wrap items-center justify-between gap-3 mb-6 pb-4 border-b border-gray-100">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-xl bg-emerald/10 flex items-center justify-center text-emerald">
                        <BookOpen size={16} />
                    </div>
                    <div className="text-left">
                        {showTitle && (
                            <span className="text-[10px] font-outfit font-black text-emerald uppercase tracking-widest block">
                                Daily Reflection 30 Hari
                            </span>
                        )}
                        <div className="flex items-center gap-2">
                            <span className="text-xs font-bold text-gray-800">
                                Hari ke-<strong className="text-emerald">{current.day}</strong> dari 30
                            </span>
                            {isToday ? (
                                <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                                    <Calendar size={10} /> Refleksi Hari Ini
                                </span>
                            ) : (
                                <button
                                    onClick={handleResetToday}
                                    className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                                    title="Kembali ke refleksi hari ini"
                                >
                                    <RotateCcw size={10} /> Kembali ke Hari Ini
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Day selector dropdown */}
                <div className="flex items-center gap-1.5">
                    <button
                        onClick={handlePrev}
                        className="p-1.5 rounded-lg border border-gray-200 text-gray-500 hover:text-emerald hover:border-emerald/40 transition-all cursor-pointer"
                        title="Refleksi Sebelumnya"
                    >
                        <ChevronLeft size={16} />
                    </button>
                    <select
                        value={index}
                        onChange={(e) => {
                            setIndex(Number(e.target.value));
                            setCopied(false);
                        }}
                        className="text-xs font-bold bg-gray-50 border border-gray-200 rounded-lg py-1.5 px-2.5 text-gray-700 focus:outline-none focus:ring-1 focus:ring-emerald cursor-pointer max-w-[140px] sm:max-w-[180px] truncate"
                    >
                        {REFLECTIONS.map((ref, idx) => (
                            <option key={ref.day} value={idx}>
                                Hari {ref.day}: {ref.theme}
                            </option>
                        ))}
                    </select>
                    <button
                        onClick={handleNext}
                        className="p-1.5 rounded-lg border border-gray-200 text-gray-500 hover:text-emerald hover:border-emerald/40 transition-all cursor-pointer"
                        title="Refleksi Berikutnya"
                    >
                        <ChevronRight size={16} />
                    </button>
                </div>
            </div>

            {/* Tema Refleksi */}
            <div className="mb-4">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-50 text-amber-800 text-[11px] font-bold border border-amber-200/70">
                    <span>Tema: {current.theme}</span>
                </span>
            </div>

            {/* Arabic Text */}
            <div className="my-6 px-2">
                <p className="font-amiri text-2xl sm:text-3xl md:text-4xl text-emerald leading-loose tracking-wide">
                    {current.ayah}
                </p>
            </div>

            {/* Translation and Source */}
            <div className="max-w-xl mx-auto space-y-2.5 mb-6">
                <p className="font-outfit text-gray-800 font-semibold text-sm sm:text-base md:text-lg leading-relaxed">
                    "{current.translation}"
                </p>
                <p className="font-outfit text-xs font-black text-gold uppercase tracking-wider">
                    — {current.source}
                </p>
            </div>

            {/* Tadabbur & Hikmah Box */}
            <div className="p-4 rounded-2xl bg-emerald-50/70 border border-emerald-100/80 text-xs sm:text-sm text-emerald-950 font-medium leading-relaxed text-left max-w-xl mx-auto mb-8 flex items-start gap-3 shadow-2xs">
                <span className="text-base shrink-0 mt-0.5">🌱</span>
                <div>
                    <strong className="font-bold text-emerald-900 block mb-0.5 text-xs uppercase tracking-wider">Tadabbur Jiwa Hari Ini:</strong>
                    <p className="text-emerald-900/90 text-xs sm:text-sm leading-relaxed">{current.hikmah}</p>
                </div>
            </div>

            {/* Controls */}
            <div className="flex flex-wrap justify-center items-center gap-3">
                <button
                    onClick={handleCopy}
                    className="p-3 rounded-xl bg-white border border-gray-200 hover:bg-emerald-50 hover:text-emerald text-gray-600 transition-all duration-300 flex items-center gap-2 text-xs font-bold font-outfit shadow-2xs cursor-pointer"
                    title="Copy Verse"
                >
                    {copied ? (
                        <>
                            <Check size={14} className="text-emerald" />
                            <span className="text-emerald">Tersalin!</span>
                        </>
                    ) : (
                        <>
                            <Copy size={14} />
                            <span>Salin Refleksi</span>
                        </>
                    )}
                </button>

                <button
                    onClick={handleNext}
                    className="px-6 py-3 rounded-xl bg-gradient-to-r from-emerald to-gold hover:opacity-95 text-white font-outfit font-black text-xs transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2 cursor-pointer"
                >
                    <Sparkles size={14} />
                    <span>Tadabbur Lainnya ({index + 1}/30)</span>
                </button>

                <button
                    onClick={handleShare}
                    className="p-3 rounded-xl bg-white border border-gray-200 hover:bg-emerald-50 hover:text-emerald text-gray-600 transition-all duration-300 shadow-2xs cursor-pointer"
                    title="Share Verse"
                >
                    <Share2 size={14} />
                </button>
            </div>
        </div>
    );
};
